import _ from 'lodash';
import {
  FETCH_REQUEST_TESTS,
  CHANGE_TEST_FIELD,
  FETCH_TEST_REPORTS,
  CLEAR_TESTS
} from 'actions/types';

const fetchTests = (action, state) => {
  if (!action.payload.data) return state;
  return action.payload.data.data;
};

const changeField = (action, state) => {
  if (!action.payload) return state;

  const { field, value, testId } = action.payload;
  const ind = _.findIndex(state, ['id', testId]);

  if (ind > -1) {
    const newState = [...state];
    newState[ind][field] = value;
    return newState;
  }

  return state;
};

const fetchReports = (action, state) => {
  if (!action.payload.data) return state;

  const data = action.payload.data.data;

  if (data.length) {
    const testId = data[0].requesttestid;
    const ind = _.findIndex(state, ['id', testId]);

    if (ind > -1) {
      const newState = [...state];
      newState[ind].reports = data;
      return newState;
    }
  }
  return state;
};

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_REQUEST_TESTS:
      return fetchTests(action, state);
    case CHANGE_TEST_FIELD:
      return changeField(action, state);
    case FETCH_TEST_REPORTS:
      return fetchReports(action, state);
    case CLEAR_TESTS:
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tests.js